import { forwardRef } from 'react';
import { getFormFieldStyles, getFormFieldMessageStyles } from './FormFieldStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { FieldMessage } from '../Field/FieldMessage/FieldMessage.js';

const FormField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    message,
    children,
    ...rest
  } = props;
  return jsxs("div", {
    css: getFormFieldStyles(message === null || message === void 0 ? void 0 : message.content),
    ref: ref,
    ...rest,
    children: [children, message && jsx(FieldMessage, {
      type: message.type,
      css: getFormFieldMessageStyles(message === null || message === void 0 ? void 0 : message.content),
      children: message.content
    })]
  });
});
FormField.displayName = 'FormField';

export { FormField };
//# sourceMappingURL=FormField.js.map
